import { Inventory } from '../../../src/feature/inventory/inventory';
import { canCarry, getCapacity, getWeight } from './capacity';
import { ItemId } from './items';

const state = () => Inventory.getInstance().getState();

export const getItemCount = (id: ItemId): number => state().items[id] ?? 0;

export const hasItem = (id: ItemId): boolean => getItemCount(id) > 0;

// True if the player can carry one more of this item by weight.
export const canHoldMore = (id: ItemId): boolean => canCarry(state(), id);

export const currentWeight = (): number => getWeight(state());

export const carryCapacity = (): number => getCapacity(state());
